import React, { useMemo, useState } from "react";
import { View }                          from "react-native";

import Row                                     from "~/layouts/Row";
import Col                                     from "~/layouts/Col";
import Heading                                 from "~/components/Heading";
import IconButton                              from "~/components/Buttons/IconButton";
import KeypadPanel                              from "~/modals/KeypadModal/Panel/";
import palette                                 from "~/styles/palette";
import useTwilio                               from "~/hooks/useTwilio";

export default function ActiveCallPanel() {
  const { startCall, endCall, callDuration, activeCall, callStatus, callState, toggleMute, toggleSpeaker, destination } =
    useTwilio();

  const [muted, setMuted] = useState(false);
  const [keypad, setKeypad] = useState(false);

  const onMute = () => {
    toggleMute(!muted);
    setMuted(!muted);
  };

  const onKeypad = () => {
    setKeypad(!keypad);
  };

  const onEndCall = () => {
    endCall();
  };

  const onAcceptIncomingCall = () => {
    if (callState.invited) {
      startCall();
    }
  };

  const onRejectIncomingCall = () => {
    endCall();
  };

  const headerText = useMemo(() => {
    if (destination?.participant?.name) {
      return destination?.participant?.name;
    }

    if (destination?.phoneNumber) {
      return destination?.phoneNumber;
    }

    if (
      activeCall?.customParameters &&
      activeCall?.customParameters.has("participantName") &&
      !callState.success &&
      callState?.invited
    ) {
      return `Incoming Call\n${activeCall?.customParameters?.get('participantName')}`;
    }

    if (
      activeCall?.customParameters &&
      activeCall?.customParameters.has("participantName") &&
      callState?.invited
    ) {
      return activeCall?.customParameters?.get('participantName');
    }

    if (
      !callState?.success &&
      callState?.invited &&
      activeCall
    ) {
      return "Incoming Call";
    }
  }, [destination, activeCall, callState]);

  if (keypad) {
    return <KeypadPanel onClose={onKeypad} />;
  }

  return (
    <View
      style={{
        backgroundColor: palette.navy,
        flex: 1,
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        flexDirection: "column",
      }}
    >
      <Row center>
        <Heading size={1} color={palette.white} center>
          {headerText}
        </Heading>
      </Row>

      <Row center style={{ opacity: 0.8 }}>
        <Heading size={4} color={palette.grey}>
          {callStatus || callDuration}
        </Heading>
      </Row>

      <Row height={128} mt={80} centered>
        <Col center>
          <IconButton
            fa
            iconName="microphone-slash"
            iconColor={muted ? palette.black : palette.white}
            color={muted ? palette.white : palette.black}
            style={{ opacity: 0.8 }}
            height={80}
            width={80}
            iconSize={32}
            onPress={onMute}
          />
          <Heading size={5} mt={16} color={palette.white} center>
            Mute
          </Heading>
        </Col>

        <Col center>
          <IconButton
            fa
            onPress={onKeypad}
            iconName="th"
            iconColor={palette.white}
            color={palette.black}
            style={{ opacity: 0.8 }}
            height={80}
            width={80}
            iconSize={32}
          />
          <Heading size={5} mt={16} color={palette.white}>
            Keypad
          </Heading>
        </Col>
      </Row>

      <Row height={80} mt={56}>
        {callState.invited && !callState.success && activeCall ? (
          <>
            <Col center>
              <IconButton
                iconName="phone"
                iconColor={palette.white}
                color={palette.danger}
                iconSize={32}
                style={{
                  transform: [{ rotateZ: "135deg" }],
                }}
                height={80}
                width={80}
                onPress={onRejectIncomingCall}
              />
            </Col>

            <Col center>
              <IconButton
                iconName="phone"
                iconColor={palette.white}
                color={palette.success}
                iconSize={32}
                height={80}
                width={80}
                onPress={onAcceptIncomingCall}
              />
            </Col>
          </>
        ) : (
          <Col center>
            <IconButton
              iconName="phone"
              iconColor={palette.white}
              color={palette.danger}
              iconSize={32}
              style={{
                transform: [{ rotateZ: "135deg" }],
              }}
              height={80}
              width={80}
              onPress={onEndCall}
            />
          </Col>
        )}
      </Row>
    </View>
  );
}
